import { render, staticRenderFns } from "./huiLearning.vue?vue&type=template&id=25b050bd&scoped=true&"
import script from "./huiLearning.vue?vue&type=script&lang=js&"
export * from "./huiLearning.vue?vue&type=script&lang=js&"
import style0 from "./huiLearning.vue?vue&type=style&index=0&id=25b050bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b050bd",
  null
  
)

export default component.exports